export enum SectionState {
  CREATING = 'CREATING',
  EDITING = 'EDITING',
  VIEWING = 'VIEWING'
}
